import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router keeps the scroll position across client-side navigations, so
// e.g. clicking a footer link would open the next page scrolled to the
// bottom. Reset to the top whenever the path changes.
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
